/**
 * Redux slice for Referral Order submission state.
 *
 * Manages:
 * - Order submission loading/error states
 * - Submission status tracking
 *
 * Pattern: Follows smartSlice.ts pattern with simple synchronous reducers.
 * Async logic handled in components/services.
 */
import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    submitting: false,
    error: null,
    lastSubmittedAt: null
};
const referralOrderSlice = createSlice({
    name: 'referralOrder',
    initialState,
    reducers: {
        /**
         * Set submitting state
         */
        setSubmitting: (state, action) => {
            state.submitting = action.payload;
            if (action.payload) {
                state.error = null;
            }
        },
        /**
         * Set submission success
         */
        setSubmitSuccess: (state) => {
            state.submitting = false;
            state.error = null;
            state.lastSubmittedAt = Date.now();
        },
        /**
         * Set error state
         */
        setError: (state, action) => {
            state.error = action.payload;
            state.submitting = false;
        },
        /**
         * Clear error state
         */
        clearError: (state) => {
            state.error = null;
        },
        /**
         * Clear all referral order state
         */
        clearReferralOrder: () => {
            return Object.assign({}, initialState);
        }
    }
});
export const { setSubmitting, setSubmitSuccess, setError, clearError, clearReferralOrder } = referralOrderSlice.actions;
export default referralOrderSlice.reducer;
